import { Typography } from "@mui/material"
import PropTypes from "prop-types"

export const HelperNote = ({ note = "Please provide required note" }) => {
    return <Typography fontStyle='italic' paddingBottom={2}>({note})</Typography>
}

HelperNote.propTypes = {
    note: PropTypes.string,
}